/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `use_case_description` - use_case_description
 * * `use_case_purpose` - use_case_purpose
 * * `ai_model_description` - ai_model_description
 * * `ai_model_training_data_description` - ai_model_training_data_description
 * @export
 */
export const FieldEnum = {
  useCaseDescription: 'use_case_description',
  useCasePurpose: 'use_case_purpose',
  aiModelDescription: 'ai_model_description',
  aiModelTrainingDataDescription: 'ai_model_training_data_description',
} as const;
export type FieldEnum = (typeof FieldEnum)[keyof typeof FieldEnum];

export function instanceOfFieldEnum(value: any): boolean {
  for (const key in FieldEnum) {
    if (Object.prototype.hasOwnProperty.call(FieldEnum, key)) {
      if ((FieldEnum as Record<string, FieldEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FieldEnumFromJSON(json: any): FieldEnum {
  return FieldEnumFromJSONTyped(json, false);
}

export function FieldEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldEnum {
  return json as FieldEnum;
}

export function FieldEnumToJSON(value?: FieldEnum | null): any {
  return value as any;
}
